import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';
import logo from '../assets/img/theme/tzone-logo-450x200.png';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n, useTranslation } from '../i18n';
import API_BASE_URL from '../config/api';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { language } = useI18n();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_BASE_URL}/auth/forgot-password`,
        { email },
        { headers: { 'Accept-Language': language } }
      );
      setMessage(t('forgotPassword.submitSuccess'));
    } catch (error) {
      setMessage(error.response?.data?.error || t('forgotPassword.submitError'));
    }
  };

  return (
    <div className="login-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <LanguageSwitcher dark />
      </div>

      <div className="login-logo">
        <img src={logo} alt="TZone Logo" />
      </div>
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>{t('forgotPassword.title')}</h2>
        <label>{t('common.email')}:</label>
        <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <button type="submit">{t('common.send')}</button>
        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default ForgotPassword;